import { IPermissionsConfig } from '@/store/modules/main/intefaces/IConfig'

export function getValueByLabel (arrayData: IPermissionsConfig | string, searchString: string) {
  // Parse the JSON array if it hasn't been parsed already
  if (typeof arrayData === 'string') {
    arrayData = JSON.parse(arrayData)
  }

  if (searchString === 'Home Page' || searchString === 'About Ursus' || searchString === 'News & Events') {
    return true
  }

  if (Array.isArray(arrayData) && arrayData.length) {
    let result: string | false = false
    arrayData.forEach((item) => {
      if (item.label === searchString && item.value === '1') {
        result = item.value
        // Early return if a match is found
      }
    })
    return result
  }
  return false
}
